import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Store } from "lucide-react";

/**
 * SelectShopForSaleDialog - Prompts user to select a shop before creating a new sale
 * 
 * This prevents accidentally creating sales in the wrong shop when a user
 * has access to multiple shops.
 */
export function SelectShopForSaleDialog({ open, onOpenChange, shops, onSelectShop }) {
  if (!open) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="select-shop-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Store className="w-5 h-5" />
            Select Shop for New Sale
          </DialogTitle>
          <DialogDescription>
            Choose the shop where you want to create this sale.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          {shops.map((shop) => (
            <button
              key={shop.id}
              onClick={() => {
                onSelectShop(shop);
                onOpenChange(false);
              }}
              className="flex items-center gap-4 p-4 rounded-lg border-2 border-[hsl(var(--border))] hover:border-[#9E6D5B] hover:bg-[#9E6D5B]/5 transition-all text-left group"
              data-testid={`shop-select-${shop.id}`}
            >
              <div className="w-12 h-12 rounded-lg bg-[#9E6D5B]/10 flex items-center justify-center group-hover:bg-[#9E6D5B]/20 transition-colors">
                <Store className="w-6 h-6 text-[#9E6D5B]" />
              </div>
              <div className="flex-1">
                <div className="font-semibold text-base">{shop.name}</div>
                {shop.address && (
                  <div className="text-sm text-muted-foreground">{shop.address}</div>
                )}
              </div>
            </button>
          ))}
        </div>

        <div className="flex justify-end">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
